import React from "react";
import SiteHeader from "../components/SiteHeader";
import Reveal from "../components/Reveal";
import ApplicationForm, { ApplicationField } from "../components/ApplicationForm";
import { IconCheck } from "../components/Icons";
import { useDocumentMeta } from "../useDocumentMeta";
import { CAMIGUIN_TOWNS } from "../data/riders";

const FIELDS: ApplicationField[] = [
  { name: "fullName", label: "Your name", type: "text", required: true, autoComplete: "name", placeholder: "Maria Santos" },
  { name: "business", label: "Business name", type: "text", required: true, autoComplete: "organization", placeholder: "Santos Eatery" },
  {
    name: "type",
    label: "Type of business",
    type: "select",
    required: true,
    options: ["Restaurant or café", "Grocery or sari-sari store", "Pharmacy", "Hardware", "Laundry", "Other"],
  },
  { name: "town", label: "Town", type: "select", required: true, options: CAMIGUIN_TOWNS },
  { name: "phone", label: "Mobile number", type: "tel", required: true, autoComplete: "tel", placeholder: "09XX XXX XXXX" },
  { name: "email", label: "Email", type: "email", autoComplete: "email", placeholder: "you@business.com" },
];

/* Plans, trial, and commission are deliberately absent: those live behind
   SHOW_MERCHANT_PLANS on the home page and FAQ. This page only collects sign-ups. */
const PERKS = [
  "Reach customers shopping in Foods and Pabili",
  "Riders pay for each order at pickup",
  "Manage incoming orders from the PABS merchant dashboard",
];

const MerchantsPage: React.FC = () => {
  useDocumentMeta({
    title: "Sell on PABS — List your store",
    description:
      "List your restaurant, grocery, or pharmacy on PABS and reach customers ordering in your town. Tell us about your business and our team will get in touch.",
    canonicalPath: "/merchants",
    ogImage: "https://pabs.online/logo512.png",
  });

  return (
    <>
      <SiteHeader current="/merchants" />

      <main id="main" className="ct">
        <section className="ct__hero">
          <div className="ct__bg" aria-hidden="true" />
          <div className="u-container">
            <Reveal className="ct__head">
              <span className="t-eyebrow">Sell on PABS</span>
              <h1 className="t-h1 ct__title">
                Bring your store <span className="t-grad">to PABS.</span>
              </h1>
              <p className="t-lead ct__lead">
                Tell us about your business and our team will get in touch to set
                up your store.
              </p>
            </Reveal>

            <div className="ct__layout">
              <Reveal className="ct__aside">
                <div className="ct__panel">
                  <h2 className="ct__panel-title">Why sell on PABS</h2>
                  <ul className="ap__list">
                    {PERKS.map((p) => (
                      <li key={p}>
                        <IconCheck size={16} />
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="ct__panel">
                  <h2 className="ct__panel-title">How it works</h2>
                  <ol className="ap__steps">
                    <li>
                      <span>
                        <b>Send this form</b>
                        It takes a minute.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>We get in touch</b>
                        We confirm your business details and set up your store.
                      </span>
                    </li>
                    <li>
                      <span>
                        <b>Start receiving orders</b>
                        Customers find you in the PABS app.
                      </span>
                    </li>
                  </ol>
                </div>
              </Reveal>

              <Reveal delay={100} className="ct__formwrap" id="apply">
                <ApplicationForm
                  source="Merchant sign-up"
                  fields={FIELDS}
                  nameField="fullName"
                  phoneField="phone"
                  emailField="email"
                  submitLabel="Send my details"
                  successMessage="Thanks! We've received your details and our team will get in touch to set up your store."
                />
              </Reveal>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default MerchantsPage;
